class Email {
    address;
    isVerified;
    constructor(data) {
        this.address = data.email;
        this.isVerified = data.isEmailVerified;
    }
}
export default Email;
